import { render } from "./Carriers.vue?vue&type=template&id=53288c15"
import script from "./Carriers.vue?vue&type=script&lang=ts"
export * from "./Carriers.vue?vue&type=script&lang=ts"
script.render = render

export default script